import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import MarketingPageRouteView from './pages/MarketingPageRouteView.vue';
import CampaignPage from './pages/CampaignPage.vue';
import HistoryPage from './pages/HistoryPage.vue';

// Creation is unified, so the section is "compose" plus "what went out". Either
// flag opens the section; inside the composer each destination block is gated by
// its own flag.
const meta = {
  featureFlag: FEATURE_FLAGS.BROADCASTS,
  permissions: ['administrator'],
};

const marketingRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/marketing'),
      component: MarketingPageRouteView,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'marketing_new_campaign', params: to.params }),
        },
        {
          path: 'new',
          name: 'marketing_new_campaign',
          meta,
          component: CampaignPage,
        },
        {
          path: 'history',
          name: 'marketing_history',
          meta,
          component: HistoryPage,
        },
        // Las dos rutas anteriores quedan como redirect para no romper links guardados.
        {
          path: 'broadcasts',
          redirect: to => ({ name: 'marketing_history', params: to.params }),
        },
        {
          path: 'posts',
          redirect: to => ({ name: 'marketing_history', params: to.params }),
        },
      ],
    },
  ],
};

export default marketingRoutes;
